import './styles.scss'

import { Tabs } from 'antd'
import type { TabPaneProps, TabsProps } from 'antd'

const { TabPane } = Tabs

interface B2becStepItemLabelProps {
  index: number
  label: string
}

export const B2becSteps = (props: TabsProps) => {
  return <Tabs {...props} className="b2bec-tab__steps" />
}

export const B2becStepItem = (props: TabPaneProps) => {
  return <TabPane {...props} className="b2bec-tab__step-item" />
}

export const B2becStepItemLabel = ({
  index,
  label,
}: B2becStepItemLabelProps) => {
  return (
    <>
      <span className="b2bec-tab__step-item__index">{index}</span>
      <span className="b2bec-tab__step-item__label">{label}</span>
    </>
  )
}
